<template>
    <nuxt-link
        :to="checkoutLink"
        class="product-select-bidding__submit-button btn btn-primary btn-lg btn-block text-uppercase"
        :class="{ 'product-select-bidding__submit-button--disabled': disabled }"
    >
        <slot>{{ $t('BiddingCheckoutLink.placeBid') }}</slot>
    </nuxt-link>
</template>

<script>
export default {
    name: 'BiddingCheckoutLink',

    props: {
        productVariantId: {
            type: [Number, String],
            required: true
        },
        bidAmount: {
            required: true
        },
        disabled: Boolean
    },

    computed: {
        checkoutLink() {
            return {
                name: 'checkout',
                query: {
                    productVariantId: this.productVariantId,
                    bidAmount: this.bidAmount,
                    mobileTeaser: true // TODO: clear up if we show for all products on mobile
                }
            };
        }
    }
};
</script>

<style scoped lang="scss">
.product-select-bidding {
    &__submit-button {
        &--disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    }
}
</style>
